import React from "react";
import { useGoogleSheetsAuth } from "./useGoogleSheetAuth";

const googleSheetAuthContext = React.createContext<
  ReturnType<typeof useGoogleSheetsAuth>
>({
  accessToken: null,
  error: null,
  logout: () => {},
  ready: false,
  requestToken: () => {},
});

export const GoogleSheetAuthProvider = (_p: { children: React.ReactNode }) => {
  const p = useGoogleSheetsAuth(
    "https://www.googleapis.com/auth/spreadsheets.readonly"
  );
  return (
    <googleSheetAuthContext.Provider value={p}>
      {_p.children}
    </googleSheetAuthContext.Provider>
  );
};

export const useGoogleSheetsAuthContext = () =>
  React.useContext(googleSheetAuthContext);
